/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
import { keycloakStaticConfig, DynamicConfigs } from '../dynamic-configs-exports';

export default angular.module('tektelic.api.keycloak', [])
    .factory('keycloakService', KeycloakService)
    .name;

/*@ngInject*/
function KeycloakService($rootScope, $q, $window, $log, $http) {

    let keycloakConfiguration;

    /* eslint-disable angular/window-service, no-undef, angular/log, no-console */
    const host = window.location.hostname;

    function selectKeycloakRealm() {
        // Priority 1: Check domain prefix (realm2 - backward compatibility)
        if (host.startsWith(DynamicConfigs.keycloak2UrlPrefix)) {
            console.log('Selected keycloak2 realm by domain prefix');
            return DynamicConfigs.keycloak2Realm;
        }

        // Priority 2: Check URL parameter for dynamic realm configurations
        const urlParams = new URLSearchParams(window.location.search);
        const ssoRealmParam = urlParams.get('sso_realm');
        if (ssoRealmParam) {
            sessionStorage.setItem('sso_realm', ssoRealmParam); // Store realm parameter in sessionStorage for subsequent requests
            console.log('Selected realm by URL parameter:', ssoRealmParam);
            return ssoRealmParam;
        } else {
            // Clear sessionStorage if parameter is not present
            sessionStorage.removeItem('sso_realm');
            console.log('Cleared sso_realm from sessionStorage');
        }

        // Default realm:
        console.log('Selected default keycloak realm');
        return DynamicConfigs.keycloakRealm;
    }

    if (DynamicConfigs.keycloakEnabled === 'true') {
        const realm = selectKeycloakRealm();
        keycloakConfiguration = {
            ...keycloakStaticConfig,
            url: `https://${DynamicConfigs.keycloakDomain}`,
            realm: realm,
            clientId: `${realm}-ui`
        }
    }
    /* eslint-enable angular/window-service, no-undef, angular/log, no-console */

    var service = {
        login: login,
        logout: logout,
        processCallback: processCallback,
        refreshToken: refreshToken
    }

    return service;

    function getRealmUrl(){
        return `${keycloakConfiguration.url}/realms/${keycloakConfiguration.realm}/protocol/openid-connect`;
    }

    function appendSsoRealmParam(uri) {
        const ssoRealm = $window.sessionStorage.getItem('sso_realm');
        if (ssoRealm) {
            const separator = uri.includes('?') ? '&' : '?';
            return uri + separator + 'sso_realm=' + encodeURIComponent(ssoRealm);
        }
        return uri;
    }

    function login() {
        const redirectUri = appendSsoRealmParam(keycloakConfiguration.redirectUri);
        let loginUrl = getRealmUrl() + `/auth`
            + '?response_type=code'
            + '&client_id=' + encodeURIComponent(keycloakConfiguration.clientId)
            + '&redirect_uri=' + encodeURIComponent(redirectUri)
            + '&scope=' + encodeURIComponent("openid " + keycloakConfiguration.scope);
        $window.location.replace(loginUrl);
    }

    function logout(idToken, activateToken) {
        let postLogoutRedirectUri;
        if (activateToken) {
            postLogoutRedirectUri = keycloakConfiguration.logoutCreatePasswordUri + '?activateToken=' + activateToken;
        } else {
            postLogoutRedirectUri = keycloakConfiguration.logoutUri;
        }
        postLogoutRedirectUri = appendSsoRealmParam(postLogoutRedirectUri);
        let logoutUrl = getRealmUrl() + `/logout`
            + '?post_logout_redirect_uri=' + encodeURIComponent(postLogoutRedirectUri)
            + '&id_token_hint=' + encodeURIComponent(idToken);
        $window.location.replace(logoutUrl);
    }

    function processCallback(code) {
        var deferred = $q.defer();
        let config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': '*/*'
            },
            withCredentials: true,
            ignoreErrors: true
        }
        const redirectUri = appendSsoRealmParam(keycloakConfiguration.redirectUri);
        let url = getRealmUrl() + `/token`;
        let data = 'grant_type=authorization_code'
            + '&client_id=' + encodeURIComponent(keycloakConfiguration.clientId)
            + '&redirect_uri=' + encodeURIComponent(redirectUri)
            + '&code=' + encodeURIComponent(code)
        $http.post(url, data, config).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail(response) {
            const errorDescription = response.data && response.data.error_description;
            deferred.reject(errorDescription || null);
        });
        return deferred.promise;
    }

    function refreshToken(refreshToken) {
        var deferred = $q.defer();
        let config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': '*/*'
            },
            withCredentials: true
        }
        var url = getRealmUrl() + `/token`;
        let data = 'grant_type=refresh_token'
            + '&client_id=' + encodeURIComponent(keycloakConfiguration.clientId)
            + '&refresh_token=' + refreshToken;
        $http.post(url, data, config).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }
}



// WEBPACK FOOTER //
// ./src/app/api/keycloak.service.js